import {
	Component,
	OnInit,
	ViewChild,
	AfterViewInit,
	ElementRef,
	OnDestroy
} from '@angular/core'
import { MatDialog } from '@angular/material'
import { NgForm } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { DataTableDirective } from 'angular-datatables'
import { Subject, Subscription } from 'rxjs'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { ActivatedRoute } from '@angular/router'
import { NotificationService } from '../../../services/notification.service'
import { CompanyService } from 'src/app/services/company.service'
import { DemandService } from '../../../services/demand.service'
import { Company } from '../../../models/Company'
import { ListDemandHistory, ManyDemandForNotify, RequesterSelected } from 'src/app/models/Demand'
import { Report } from 'src/app/models/Appraisal'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { ModalDeleteDemandComponent } from '../../modal/delete-demand/modal-delete-demand.component'
import { ModalReactivateDemandComponent } from './../../modal/reactivate-demand/modal-reactivate-demand.component'
import { PATH } from 'src/app/app.api'
import { AWSService } from '../../../services/aws.service'
import * as moment_ from 'moment'
import * as moment from 'moment'
import { getEnableCommunication, getIdentifierName, getLengthTable, getLoggedUser, setLengthTable } from 'src/app/_helpers/LocalStorage'
import { DetailsFromClick } from 'src/app/models/DetailsFromClick'
import { InsertDateComponent } from '../../modal/insert-date/insert-date.component'
import { MapView } from '../../map-view/map-view.component'
import { insertOrRemoveClassInScrollButton, removeToolTip, scrollToConteiner } from 'src/app/_helpers/Utils'
import { SearchTruncated, searchTruncatedDemandHistory } from 'src/app/_helpers/SearchTruncated'
import { IItenPositionWithYourPage, getGeneralPositionOfItemSelected, recalculatePagePositionOfItensSelected } from 'src/app/_helpers/InteractionsWithTables'
import { TreeService } from 'src/app/services/tree.service'
import { ExportService } from '../../../services/export.service'
import { ColumnMapType, getTableConfiguration, setTableConfiguration, TablesPanel } from 'src/app/_helpers/Table-settings'

@Component({
	selector: 'app-demands-history',
	templateUrl: './demands-history.component.html'
})

export class DemandsHistoryComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild('form') public form: NgForm
	@ViewChild(MapView) public mapView: MapView
	@ViewChild(DataTableDirective) public dtElement: DataTableDirective
	@ViewChild('tableConteiner') public tableConteiner: ElementRef<HTMLDivElement>
	public refreshTable: Subject<any> = new Subject()
	public currentPageTable: number = 0;

	public identifierName = getIdentifierName()
	public datatableOptions: DataTables.Settings = {}
	public dataTableParams: any
	public ViewValidation: ViewValidation = new ViewValidation()
	public classifications: Array<any>
	public classificationSelected: any
	public report: Report
	public sessionUser: UserAdmin = getLoggedUser()
	public assignments: Array<string> = []
	public demands: Array<ListDemandHistory> = []
	public appraisalDemands: Array<{
		protocol: number;
		requester: string;
		cpfRequester: string;
		emailRequester: string;
		idMongo: string;
	}> = []
	public managementFromDemandSelected: Array<string> = []
	public manyDemandsForNotify: ManyDemandForNotify = new ManyDemandForNotify()
	public company: Company
	public companyId: string = localStorage.getItem('companyId')
	public companyIsActive: boolean = false
	public modalNotificationDiferentRequest: boolean = false
	public modalLaudo: boolean = false
	public modalAction: boolean = true
	public openModalManagement: boolean = false
	public appraisalId: string = ''
	public pinsForMap: Array<any> = []
	public questionStateDemand: any
	public demandSelectedFromMapView: DetailsFromClick = new DetailsFromClick()
	public numberOfAppraisals: number = 0
	public theAmountAppraisalsFiltered: number
	public searchFromDate: string = ''
	public searchText: string = ''
	public searchAddress: string = ''
	public categories: Array<any> = []
	public allowSave: boolean = false
	public files: Array<any> = [{
		report: Report,
		file: '',
		category: ''
	}]
	public updateDataTable = value => this.filterSearchTree(value)
	public isAdmin: boolean = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
	public hasPermitionAcessDocuments: boolean = Boolean(
		this.isAdmin || this.sessionUser.assignments.includes('APPRAISAL_HISTORY_DOCUMENT')
	)
	public hasPermitionDelete: boolean = Boolean(
		this.isAdmin || this.sessionUser.assignments.includes('APPRAISAL_HISTORY_CHANGE_STATUS')
	)
	public hasPermitionAttachDemand: boolean = Boolean(
		this.isAdmin || this.sessionUser.assignments.includes('APPRAISAL_HISTORY_ATTACH_DEMAND')
	)
	public hasPermitionToAccessProtectedRoutesCommunication: boolean = false
	public appraisalsManySelected: Array<string> = []
	public appraisalsManySelectedReport: Array<string> = []
	public demandSelectedToViewReport: string = ''
	public companyEnableNotification: boolean = getEnableCommunication()
	public selectAllActive: boolean = true

	public demandHistorySearchTruncated: Array<SearchTruncated> = searchTruncatedDemandHistory
	public searchTruncatedStringFormated: string = ''
	public showScrollUpButton: boolean = false
	public lengthTable: string = getLengthTable()
	public showOnlySelected: boolean = false
	public generalPositionOfItensSelected: Array<IItenPositionWithYourPage> = []
	public pagesWithItensSelected: Array<number> = []
	public openDemandsAttach: boolean = false
	public openDemandsUnattach: boolean = false
	public enableUnattachDemand: boolean = false
	public appaisalIdToAttachDemand: Array<string> = []
	public appaisalIdToUnattachDemand: string = ''
	public appraisalToAttachDemand: Array<ListDemandHistory> = []
	public showPinMoveAlertModal = false
	public showSetTable: boolean = false;
	public settingsTable: ColumnMapType = getTableConfiguration(TablesPanel.HISTORY_APPRAISAL);
	public httpListSubscription: Subscription

	constructor(
		public notificationService: NotificationService,
		private demandService: DemandService,
		private companyService: CompanyService,
		private activateRoute: ActivatedRoute,
		private treeService: TreeService,
		private awsService: AWSService,
		private http: HttpClient,
		public dialog: MatDialog,
		private readonly exportService: ExportService
	) { }

	public async ngOnInit(): Promise<void> {
		window.addEventListener('storage', this.handleAssignReportEvent)

		await this.fetchCompany()

		await this.getAllPinsFromMap()
		await this.getQuestionStateDemand()

		this.searchText =
			this.activateRoute.snapshot.queryParams.search ?
			this.activateRoute.snapshot.queryParams.search : ''

		this.fetchSessionUser()

		await this.setupDatatables()

		await this.checkCompanyStatus()


		document.querySelector('main').className = ''
		this.initTable()

		this.report = new Report()
		this.categories = [
			{ _id: 'art', name: 'ART' },
			{ _id: 'doc', name: 'Laudo Aprofundado' },
			{ _id: 'rel', name: 'Docs. Diversos' }
		]

		this.classifications = [
			{ _id: 'Baixo', name: 'Baixo' },
			{ _id: 'Moderado', name: 'Moderado' },
			{ _id: 'Provável', name: 'Provável' },
			{ _id: 'Muito alto', name: 'Muito alto' }
		]

		const observer =
			new IntersectionObserver( ([entry]) => {
				this.showScrollUpButton = entry.isIntersecting

				if (entry.isIntersecting) {
					insertOrRemoveClassInScrollButton()
				}
			})

		observer.observe(this.tableConteiner.nativeElement)
	}

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

	private async setupDatatables(): Promise<void> {
		this.datatableOptions = {
			language: {
				processing: 'Processando...',
				lengthMenu: '_MENU_ resultados por página',
				info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
				infoEmpty: 'Mostrando 0 até 0 de 0 registros',
				infoFiltered: '',
				infoPostFix: '',
				zeroRecords: '...',
				loadingRecords: 'Cargando...',
				emptyTable: 'Nenhum registro encontrado',
				paginate: {
					first: 'Primero',
					previous: 'Anterior',
					next: 'Próximo',
					last: 'Último'
				},
				aria: {
					sortAscending: ': Ordenar colunas de forma ascendente',
					sortDescending: ': Ordenar colunas de forma ascendente'
				}
			},
			pagingType: 'full_numbers',
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: Number(this.lengthTable),
			lengthChange: false,
			columnDefs: [
				{
					targets: [6],
					type: 'date'
				},
				{
					targets: [6],
					type: 'date'
				}
			],
			order: [[4, 'desc']],
			orderMulti: true,
			serverSide: true,
			processing: true,

			ajax: (dataTablesParameters: any, callback) => {
				if (this.httpListSubscription) {
					this.httpListSubscription.unsubscribe()
				}

				const url = this.buildUrlWithParams(dataTablesParameters)

				this.httpListSubscription = this.http
					.get<any>(url)
						.subscribe(resp => {
						this.currentPageTable = Math.floor(dataTablesParameters.start / dataTablesParameters.length)
						this.demands = resp.content
						this.numberOfAppraisals = resp.numberOfPages
						this.dataTableParams = dataTablesParameters
						callback({
							recordsFiltered: resp.numberOfPages,
							recordsTotal: resp.numberOfPages,
							data: []
						})
						this.switchSelectAllButton(true)
					})
			},
			columns: [
				{ data: 'actions' , orderable: false },
				{ data: 'select' , orderable: false },
				{ data: 'process' },
				{ data: 'identifier' },
				{ data: 'treeId' },
				{ data: 'osa' },
				{ data: 'data' },
				{ data: 'requester' , orderable: false },
				{ data: 'protocol' },
				{ data: 'evaluator' },
				{ data: 'address' },
				{ data: 'region' , orderable: false },
				{ data: 'degreeRisk' },
				{ data: 'management' , orderable: false },
				{ data: 'communication' , orderable: false },
				{ data: 'communicationId' },
			]
		}
	}

	private buildUrlWithParams(dataTablesParameters): string {
		const orderBy = dataTablesParameters.columns[dataTablesParameters.order[0].column].data
		const orderByDirection = dataTablesParameters.order[0].dir

		const tableLength = getLengthTable()

		// Construção da URL
		let url = `${PATH}/demand/history?companyId=${this.companyId}&userId=${this.sessionUser._id}`
		url += `&skip=${dataTablesParameters.start}&limit=${tableLength}&orderBy=${orderBy}`
		url += `&orderByDirection=${orderByDirection}&search=${this.searchText}&searchFromDate=${this.searchFromDate}`

		if (this.searchTruncatedStringFormated) {
			url += `&searchTruncatedStringFormated=${this.searchTruncatedStringFormated}`
		}

		if (this.showOnlySelected) {
			url += `&onlySelected=true&itensSelected=${this.appraisalsManySelected}`
		}

		return url
	}

	public async fetchCompany(): Promise<void> {
		try {
			const response: Company =
				await this.companyService.detailCompany(this.companyId).toPromise()

			this.company = response
		} catch (err) { }
	}

	public async checkCompanyStatus(): Promise<void> {
		try {
			const companyStatus: string =
				await this.companyService.checkStatus(this.companyId).toPromise()

			if (companyStatus === 'ACTIVE') {
				this.companyIsActive = true

				return
			}

			this.companyIsActive = false
		} catch (err) {
			console.log(err)
		}
	}

	public fetchSessionUser(): void {
		this.companyId = localStorage.getItem('companyId')

		this.hasPermitionToAccessProtectedRoutesCommunication = Boolean(
			this.isAdmin ||
			this.sessionUser.roles.includes('USER') ||
			this.sessionUser.roles.includes('CUSTOMER') ||
			this.sessionUser.assignments.includes('APPRAISAL_HISTORY_VIEW_COMMUNICATION')
		)

		this.sessionUser.assignments.forEach(assignment => {
			this.assignments.push(assignment)
		})

		this.enableUnattachDemand = Boolean(
			this.isAdmin ||
			this.assignments.includes('APPRAISAL_HISTORY_UNATTACH_DEMAND')
		)
	}

	public async getAllPinsFromMap(): Promise<any> {
		this.pinsForMap =
			await this.demandService.getDemandsHistory(this.companyId).toPromise()
	}

	public async getQuestionStateDemand(): Promise<void> {
		this.questionStateDemand =
			await this.demandService.getQuestionStateTree(this.companyId).toPromise()
	}

	public async setDemandSelectFromTable(demand: ListDemandHistory) {

		const mapBody = document.getElementsByClassName('map-content')[0]

		mapBody.scrollIntoView({
			behavior: 'smooth'
		})

		const demandSelected: DetailsFromClick =
			await this.demandService.getClickTree(demand.idMongo, this.companyId).toPromise()

		this.demandSelectedFromMapView = demandSelected
	}

	public async updateMapCache() {
		this.pinsForMap =
			await this.demandService.updateMapCache(this.companyId, this.sessionUser.email).toPromise()
	}

	public async updateLocationPin(data: any) {
		this.showPinMoveAlertModal = true

		await this.demandService.updateLocationPinMapHistory(
			data.idMongo,
			data.location
		).toPromise()
	}

	public closeAlertModal() {
		this.showPinMoveAlertModal = false
	}

	public demandHisEvaluator(evaluationId: string): boolean {
		return Boolean(
			this.sessionUser.roles.includes('GENERAL_ADMIN') ||
			this.sessionUser.roles.includes('CUSTOMER') ||
			this.sessionUser.roles.includes('USER') ||
			(evaluationId == this.sessionUser._id &&
			 	this.assignments.includes('APPRAISAL_REPORT_READ')) ||
			this.assignments.includes('APPRAISAL_REPORT_READ_ALL')
		)
	}

	public async filterSearchTree(value: any): Promise<void> {

		const isData = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/

		if (isData.test(value)) {
			this.searchFromDate = moment_(value, 'DD/MM/YYYY').format(
				'YYYY-MM-DD'
			)
		} else {
			this.searchFromDate = ''
			this.searchText = value.toLowerCase() == 'muito alto' ? 'muito_alto' : value
		}

		this.clearSelections()
		this.reloadTable()
	}

	public refreshAppraisals(): void {
		this.closeModal()
		this.reloadTable()
		this.report = new Report()
		this.classificationSelected = {}
		this.files = [{ category: {} }]
	}

	public reloadTable(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				const currentPage: number = dtInstance.page()

				dtInstance.ajax.reload(() => {
					dtInstance.page(currentPage).draw(false)
				}, false)
			})

			removeToolTip()
		}
	}

	public initTable(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

				// Salvar a página atual
				const currentPage: number = dtInstance.page()

				document.querySelector('table').classList.add('hide')

				// Distroy a tabela
				dtInstance.destroy()

				// Disparar o evento de atualização da tabela
				this.refreshTable.next()

				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
					// Restaurar a página atual após recriar a tabela
					if (currentPage > 0) {
						this.dtElement.dtInstance.then((newDtInstance: DataTables.Api) => {
							newDtInstance.page(currentPage).draw(false)
						})
					}
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public selectedManysAppraisals(appraisalId: string) {

		const index: number =
			this.appraisalsManySelected.indexOf(appraisalId)

		if (index == -1) {
			this.appraisalsManySelected.push(appraisalId)
		} else {
			this.appraisalsManySelected.splice(index, 1)
		}

		const indexRepost: number =
			this.appraisalsManySelectedReport.indexOf(appraisalId)

		if (indexRepost != -1) {
			this.appraisalsManySelectedReport.splice(indexRepost, 1)
		} else {
			const appraisal = this.demands.find(demand =>
				demand.idMongo == appraisalId
			)

			const appraisalWithManyRequesters: boolean = Boolean(
				appraisal.Demands.length > 1
			)

			if (!appraisalWithManyRequesters) {
				this.appraisalsManySelectedReport.push(appraisalId)
			}
		}

		this.interactWithMap()
		this.switchSelectAllButton()
	}

	public interactWithMap() {
		if (this.mapView) {
			this.mapView.changeViewPinsFromMap(true)
			this.mapView.enableOrDisableShowOnlySelectButton()
		}
	}

	public selectManyNotify(demandSelected: ListDemandHistory) {
		if (!demandSelected.enableCommunication || demandSelected.Demands.length > 1) return

		const demandAlreadySelected: boolean = this.demandIsAlreadySelected(demandSelected.idMongo)

		if (demandAlreadySelected) {
			this.removeDemandFromManyNotify({
				idMongo: demandSelected.idMongo,
				cpfRequester: demandSelected.Demands[0].cpfRequester
			})
		} else {
			this.insertDemandInManyNotify({
				idMongo: demandSelected.idMongo,
				cpfRequester: demandSelected.Demands[0].cpfRequester,
				emailRequester: demandSelected.Demands[0].emailRequester,
				requester: demandSelected.Demands[0].requester
			})
		}
	}

	private demandIsAlreadySelected(demandSelectedIdMongo: string) {
		return  Boolean(
			this.manyDemandsForNotify.idMongoDemandsSelected.includes(demandSelectedIdMongo)
		)
	}

	public insertDemandInManyNotify(demandSelected: {
		idMongo: string,
		cpfRequester: string,
		emailRequester: string,
		requester: string
	}) {
		this.manyDemandsForNotify.demandsSelected.push({
			idMongo: demandSelected.idMongo,
			cpfRequester: demandSelected.cpfRequester
		})
		this.manyDemandsForNotify.idMongoDemandsSelected.push(demandSelected.idMongo)

		const demandHasRequest: boolean = Boolean(
			demandSelected.cpfRequester !== '-'
		)
		const notHasRequesterSelected: boolean = Boolean(
			this.manyDemandsForNotify.requesterSelected.length == 0
		)
		const newRequesterSelected: boolean = Boolean(
			this.manyDemandsForNotify.requesterSelected.every(
				requester => requester.cpfRequester !== demandSelected.cpfRequester
			)
		)
		const requestAlreadySelected: boolean = Boolean(
			this.manyDemandsForNotify.requesterSelected.some(
				requester => requester.cpfRequester === demandSelected.cpfRequester
			)
		)

		if (!demandHasRequest) {
			this.manyDemandsForNotify.countDemandsWithoutRequester++
			return
		}

		if (notHasRequesterSelected || newRequesterSelected) {
			this.manyDemandsForNotify.requesterSelected.push({
				cpfRequester: demandSelected.cpfRequester,
				emailRequest: demandSelected.emailRequester,
				nameRequest: demandSelected.requester,
				numberAppraisals: 1
			})
		} else if (requestAlreadySelected) {
			this.manyDemandsForNotify.requesterSelected.forEach(requester => {
				if (requester.cpfRequester === demandSelected.cpfRequester) {
					requester.numberAppraisals++
				}
			})
		}
	}

	public removeDemandFromManyNotify(demandSelected: {idMongo: string, cpfRequester: string}) {
		const indexDemand: number =
			this.manyDemandsForNotify.demandsSelected.findIndex(demand => demand.idMongo === demandSelected.idMongo)

		const indexIdmongoDemand: number =
			this.manyDemandsForNotify.idMongoDemandsSelected.findIndex(idMongo => idMongo === demandSelected.idMongo)

		this.manyDemandsForNotify.demandsSelected.splice(indexDemand, 1)
		this.manyDemandsForNotify.idMongoDemandsSelected.splice(indexIdmongoDemand, 1)

		const demandHasRequest: boolean = Boolean(
			demandSelected.cpfRequester !== '-'
		)

		if (demandHasRequest) {
			let numberOfAppraisalsToRequesterSelected: number = 0
			let indexRequestSelected: number = -1

			this.manyDemandsForNotify.requesterSelected.forEach((requester, index) => {
				if (requester.cpfRequester === demandSelected.cpfRequester) {
					requester.numberAppraisals = requester.numberAppraisals - 1
					numberOfAppraisalsToRequesterSelected = requester.numberAppraisals
					indexRequestSelected = index
				}
			})

			if (numberOfAppraisalsToRequesterSelected === 0 && indexRequestSelected !== -1) {
				this.manyDemandsForNotify.requesterSelected.splice(indexRequestSelected, 1)
			}
		} else {
			this.manyDemandsForNotify.countDemandsWithoutRequester--
		}
	}

	public selectUniqueRequester(cpfRequest?: string) {
		const appraisalIds: Array<string> = []

		this.manyDemandsForNotify.demandsSelected.forEach(demand => {
			if (cpfRequest && demand.cpfRequester == cpfRequest) {
				appraisalIds.push(demand.idMongo)
			} else if (!cpfRequest && demand.cpfRequester == '-') {
				appraisalIds.push(demand.idMongo)
			}
		})

		this.closeModalManyNotification()
		this.runCommunicationForModal(appraisalIds)
	}

	public async runCommunicationView(appraisalId?: string) {

		let url = '#/protected/communicationAppraisal/'

		if (appraisalId) {
			url = url + appraisalId
		} else {
			const demandsSelectedFromManyRequester: boolean = Boolean(
				this.manyDemandsForNotify.requesterSelected.length > 1
			)
			const demandsSelectedWithAndWhitoutRequester: boolean = Boolean(
				this.manyDemandsForNotify.demandsSelected.some(demand =>
					demand.cpfRequester == '-'
				) && this.manyDemandsForNotify.requesterSelected.length > 0
			)

			if (demandsSelectedFromManyRequester || demandsSelectedWithAndWhitoutRequester) {
				this.modalNotificationDiferentRequest = true
				return
			}

			url = url + this.manyDemandsForNotify.idMongoDemandsSelected
		}

		const newTab = window.open(url, '_blank')
		newTab.focus()
	}

	public runCommunicationWithSpecificRequest(
		appraisalId: string,
		demandId: string
	) {
		const url = `#/protected/communicationAppraisal/${appraisalId}?demandId=${demandId}`

		const newTab = window.open(url, '_blank')
		newTab.focus()
	}

	public runCommunicationForModal(appraisalIds: Array<string>) {
		let url = '#/protected/communicationAppraisal/'

		url = url + appraisalIds

		const newTab = window.open(url, '_blank')
		newTab.focus()
	}

	public openModalChoosePrint: boolean = false

	public openSelectionModeModal(appraisalId?: string) {
		removeToolTip()

		if (appraisalId) {
			this.appraisalsManySelectedReport = [appraisalId]
		}

		this.demandSelectedToViewReport = ''
		this.openModalChoosePrint = !this.openModalChoosePrint
	}

	public openSelectionModeModalWithSpecificRequest(
		appraisalId: string,
		demandId: string
	) {
		this.appraisalsManySelectedReport = [appraisalId]
		this.demandSelectedToViewReport = demandId

		this.openModalChoosePrint = !this.openModalChoosePrint
	}

	public exportReport() {
		const type = 'evaluation-report-arboreal'

		this.treeService.exportReport({
			type,
			ids: this.appraisalsManySelectedReport,
		    demandId: this.demandSelectedToViewReport
		})

		this.openSelectionModeModal()
	}

	public runEvaluationReportArboreal() {

		let url = '#/protected/evaluationReportArboreal/'

		url = url + this.appraisalsManySelectedReport

		if (this.demandSelectedToViewReport) {
			url += `?demandId=${this.demandSelectedToViewReport}`
		}

		this.openSelectionModeModal()

		const newTab = window.open(url, '_blank')
		newTab.focus()
	}

	/*******************************************************************
	 * Exportar Excel
	 *******************************************************************/

	public async exportAsXLSXAppraisals() {

		const dialogRef = this.dialog.open(InsertDateComponent)
		dialogRef.componentInstance.close = dialogRef.close
		let dateStart: number
		let dateEnd: number

		dialogRef.afterClosed().subscribe(async result => {
			if (!dialogRef.componentInstance.cancel) {
				let dateAux = dialogRef.componentInstance.dateStart.split('/')
				dateStart = new Date(Number(dateAux[2]), Number(dateAux[1]) - 1, Number(dateAux[0])).getTime()
				dateAux = dialogRef.componentInstance.dateEnd.split('/')
				dateEnd = new Date(Number(dateAux[2]), Number(dateAux[1]) - 1, Number(dateAux[0])).getTime()
			}
			if (!dateStart || !dateEnd) return

			if (this.isAdmin) {
				this.notificationService.notify('Aguarde, estamos montando seu excel. O download iniciará em breve.', 200)
				await this.demandService.getExportAppraisalsHistory(this.companyId, dateStart, dateEnd).toPromise()
				return
			}

			const diffMonths = (dateEnd - dateStart) / (1000 * 60 * 60 * 24 * 30)

			if (diffMonths > 3 ) {
				this.notificationService.notify('O período de exportação excede o limite de três meses. Entre em contato com o administrador do sistema', 404)
				return
			}

			if (diffMonths > 1) {
				this.notificationService.notify('O período de exportação solicitado é de um mês ou mais, o arquivo será enviado para o seu email', 200)
				await this.exportService.sendExportByEmail({type: 'appraisal-historic', dateEnd, dateStart}).toPromise()
			} else {
				this.notificationService.notify('Aguarde, estamos montando seu excel. O download iniciará em breve.', 200)
				await this.demandService.getExportAppraisalsHistory(this.companyId, dateStart, dateEnd).toPromise()
			}
		})
	}

	/******************************************************************
	 * MODAL
	 *******************************************************************/

	public closeModalManyNotification() {
		this.modalNotificationDiferentRequest = false

		removeToolTip()
	}

	public async openModal(demand: ListDemandHistory): Promise<void> {
		this.modalLaudo = true
		this.modalAction = true

		this.appraisalId = demand.idMongo

		if (demand.Report.responsible) {
			this.modalAction = false
			this.report = {
				...demand.Report,
				date: moment(demand.Report.date).format('DD/MM/YYYY')
			}

			if (typeof demand.Report.file[0] === 'string') {
				this.files = [{
					file: demand.Report.file[0]
				}]
			} else {
				this.files = demand.Report.file.map(file => {
					return file
				})
			}

			this.classificationSelected = {
				_id: this.report.risk,
				name: this.report.risk
			}

			return
		}

		this.report = new Report()
	}

	public closeModal(): void {
		this.classificationSelected = ''
		this.modalLaudo = false
		this.report = new Report()
		this.classificationSelected = {}
		this.files = [
			{
				category: {

				}
			}
		]

		removeToolTip()
		this.validateData()
	}

	public onFileSelected(fileInput: any, i): void {
		const file: any = fileInput.target.files[0]

		fileInput.target.value = ''

		if (file) {
			this.notificationService.initLoading()
			this.awsService
				.uploadToS3(file)
				.then(data => {
					const aux = this.files
					aux[i] = { ...aux[i], file: data.Location }
					this.files = aux
					// this.files[i].file = data.Location
					this.notificationService.stopLoading()
					this.validateData()
				})
				.catch(err => {
					this.notificationService.notify(
						'Somente são permitidos arquivos menores que 5MB, por favor tente novamente', 420
					)
					this.notificationService.stopLoading()
				})
		}
	}

	public showReport(file: string): void {
		if (file.length > 0) {
			window.open(file)
		}
	}

	public async submitReport(): Promise<void> {
		try {
			this.report.file = this.files
			// let actualPage = Number(document.getElementsByClassName('paginate_button current')[0].innerHTML);
			const response: any =
				await this.demandService.saveReport(this.report, this.appraisalId).toPromise()

			this.refreshAppraisals()
			// this.setCurrentPage(actualPage)
			this.notificationService.notify(response.message, 200)
		} catch (err) {
			console.log(err)
		}
	}

	public addNewFile() {
		this.files.push({
			file: '',
			category: { _id: '', name: '' }
		})
	}

	public deleteFile(index) {
		if (this.files.length >= 2) {
			this.files.splice(index, 1)
		}

		removeToolTip()
	}

	public async openModalDeleteAllFilesByAppraisal(demand) {
		const dialogRef = this.dialog.open(ModalDeleteDemandComponent)

		dialogRef.afterClosed().subscribe(async () => {
			if (!dialogRef.componentInstance.cancel) {
				this.report.responsible = ''

				this.files = [{
					report: {
						responsible: '',
						date: '',
						file: [],
						risk: ''
					},
					file: '',
					category: ''
				}]
				this.submitReport()
			}
		})
	}

	public chooseCategory(event, i) {
		this.files[i] = {
			...this.files[i],
			category: event
		}
	}

	public onInputClick(event) {
		const element = event.target as HTMLInputElement
		element.value = ''
	}

	public validateData = () => {
		let auxReturn = 0

		this.files.map(file => {
			if (file.file && file.category._id) {
				auxReturn += 1
			}
		})

		this.allowSave = Boolean(this.report.responsible && auxReturn === this.files.length)
	}

	public async openModalDeleteAppraisal(demand: ListDemandHistory) {
		const id = demand.idMongo

		const dialogRef = this.dialog.open(ModalDeleteDemandComponent)

		dialogRef.afterClosed().subscribe(async () => {
			if (!dialogRef.componentInstance.cancel) {
				const response: any =
					await this.demandService.deleteAppraisal(id).toPromise()

				this.notificationService.notify(response.message, 200)

				this.refreshAppraisals()
			}
		})
	}

	public async openModalReactivate(demand: ListDemandHistory) {
		const id = demand.idMongo

		const dialogRef = this.dialog.open(ModalReactivateDemandComponent)

		dialogRef.afterClosed().subscribe(async () => {
			if (!dialogRef.componentInstance.cancel) {

				const response: any =
					await this.demandService.reactivateAppraisal(id).toPromise()

				this.notificationService.notify(response.message, 200)
				this.refreshAppraisals()
			}
		})
	}

	public selectOrUnselectAllItens() {
		if (this.selectAllActive) {
			this.selectAllItensForList()
		} else {
			this.unselectAllItensForLIst()
		}
	}

	public selectAllItensForList() {
		this.demands.forEach((item, i) => {
			if (!this.appraisalsManySelected.includes(item.idMongo)) {
				this.appraisalsManySelected.push(item.idMongo)
			}

			if (
				!this.appraisalsManySelectedReport.includes(item.idMongo) &&
				item.Demands.length < 2
			) {
				this.appraisalsManySelectedReport.push(item.idMongo)
			}

			if (
				!this.appaisalIdToAttachDemand.includes(item.idMongo) &&
				item.Demands.length === 0 &&
				!item.done &&
				item.demandStatus == 'WITHOUT_DEMAND'
			) {
				this.appaisalIdToAttachDemand.push(item.idMongo)
				this.appraisalToAttachDemand.push(item)
			}

			if (
				!this.demandIsAlreadySelected(item.idMongo) &&
				item.enableCommunication && 
				item.Demands.length <= 1
			) {
				this.insertDemandInManyNotify({
					idMongo: item.idMongo,
					cpfRequester: item.Demands[0].cpfRequester,
					emailRequester: item.Demands[0].emailRequester,
					requester: item.Demands[0].requester
				})
			}
			this.setGeneralPositionItenSelected(i, true, false)
		})

		this.interactWithMap()
		this.selectAllActive = false
	}

	public unselectAllItensForLIst() {
		this.demands.forEach((item, i) => {
			const index = this.appraisalsManySelected.indexOf(item.idMongo)

			if (index != -1) {
				this.appraisalsManySelected.splice(index, 1)
			}

			const appraisalIdToAttachIndex: number =
				this.appaisalIdToAttachDemand.indexOf(item.idMongo)

			const indexReport: number =
				this.appraisalsManySelectedReport.indexOf(item.idMongo)

			if (indexReport != -1) {
				this.appraisalsManySelectedReport.splice(indexReport, 1)
			}

			if (appraisalIdToAttachIndex != -1) {
				this.appaisalIdToAttachDemand.splice(appraisalIdToAttachIndex, 1)
			}

			const appraisalAttachIndex: number =
				this.appraisalToAttachDemand.findIndex(
					appraisal => appraisal.idMongo === item.idMongo
			)

			if (appraisalAttachIndex != -1) {
				this.appraisalToAttachDemand.splice(appraisalAttachIndex, 1)
			}

			if(this.demandIsAlreadySelected(item.idMongo)) {
				this.removeDemandFromManyNotify({
					idMongo: item.idMongo,
					cpfRequester: item.Demands[0].cpfRequester
				})
			}
			this.setGeneralPositionItenSelected(i, false, true)
		})

		this.interactWithMap()
		this.selectAllActive = true
	}

	public switchSelectAllButton(active?: boolean) {

		const itensIds: Array<string> = []

		this.demands.forEach(item => {
			itensIds.push(item.idMongo)
		})

		const allItensSelected: boolean = itensIds.every(item => this.appraisalsManySelected.includes(item))
		const allItensUnSelected: boolean = itensIds.every(item => !this.appraisalsManySelected.includes(item))

		if (allItensSelected) {
			this.selectAllActive = false
			return
		} else if (allItensUnSelected) {
			this.selectAllActive = true
			return
		}

		if (active) {
			this.selectAllActive = active
		}
	}

	public openCloseModalManagement(management?: Array<string>) {
		if (management) {
			this.openModalManagement = true
			this.managementFromDemandSelected = management
		} else {
			this.openModalManagement = false
			this.managementFromDemandSelected = []
		}
	}

	public searchTruncated(value: string) {
		this.searchTruncatedStringFormated = value
		this.clearSelections()
		this.reloadTable()
	}

	public updateLengthTable(newLength: string) {
		this.datatableOptions.pageLength = parseInt(newLength)
		this.reloadTable()
		setLengthTable(newLength)

		const newGeneralPositionItem = recalculatePagePositionOfItensSelected(
			Number(newLength),
			this.generalPositionOfItensSelected
		)
		this.generalPositionOfItensSelected = newGeneralPositionItem.allItensSelected
		this.pagesWithItensSelected = newGeneralPositionItem.allPagesSelected
	}

	public runToInitTable() {
		const table: HTMLDivElement =
			document.getElementsByClassName('datatables-content')[0] as HTMLDivElement

		scrollToConteiner(table)
		insertOrRemoveClassInScrollButton()
	}

	public viewOnlySelected() {
		this.showOnlySelected = !this.showOnlySelected

		this.reloadTable()
	}

	public setGeneralPositionItenSelected(
		indexInCurrentPage: number,
		selectingAll: boolean,
		unSelectingAll: boolean
	) {
		const generalPositionItem = getGeneralPositionOfItemSelected(
			indexInCurrentPage + 1,
			Number(this.lengthTable),
			this.generalPositionOfItensSelected,
			selectingAll,
			unSelectingAll,
			this.currentPageTable
		)
		this.generalPositionOfItensSelected = generalPositionItem.allItensSelected
		this.pagesWithItensSelected = generalPositionItem.allPagesSelected
	}

	public openModalDemandsAttach(appraisal?: ListDemandHistory) {
		if (appraisal) {
			this.appaisalIdToAttachDemand = [appraisal.idMongo]
			this.appraisalToAttachDemand = [appraisal]

			const index: number =
				this.appraisalsManySelected.indexOf(appraisal.idMongo)

			if (index == -1) {
				this.appraisalsManySelected.push(appraisal.idMongo)
			}
		}

		this.openDemandsAttach = true
	}

	public closeModalDemandsAttach() {
		this.openDemandsAttach = false
	}

	public openModalDemandsUnattach(appraisalId: string) {
		if (!this.enableUnattachDemand) return

		this.openDemandsUnattach = true
		this.appaisalIdToUnattachDemand = appraisalId
	}

	public closeModalDemandsUnattach() {
		this.openDemandsUnattach = false
	}

	public async unattachDemand() {
		this.notificationService.initLoading()

		try {
			const response =
				await this.demandService.unattachDemandInAppraisal(this.appaisalIdToUnattachDemand).toPromise()

			this.notificationService.notify(response, 200)
			this.closeModalDemandsUnattach()
			this.reloadTable()
		} catch (error) {
			console.log(`Erro ao desvincular a solicitação do Appraisal ${this.appaisalIdToUnattachDemand}. Error: ${error}`)
		}

		this.notificationService.stopLoading()
	}

	public closeModalDemandsAttachAndUpdateHistory() {
		this.openDemandsAttach = false
		this.emptyManySelectAppraisals()
		this.reloadTable()
	}

	public selectAppraisalToAttach(appraisalSelected: ListDemandHistory) {
		if (
			appraisalSelected.Demands.length > 0 ||
			appraisalSelected.done ||
			appraisalSelected.demandStatus == 'WITH_DEMAND' ||
			appraisalSelected.demandStatus == 'ADDED_DEMAND'
		) return

		const index: number =
			this.appaisalIdToAttachDemand.indexOf(appraisalSelected.idMongo)

		if (index == -1) {
			this.appaisalIdToAttachDemand.push(appraisalSelected.idMongo)
			this.appraisalToAttachDemand.push(appraisalSelected)
		} else {
			this.appaisalIdToAttachDemand.splice(index, 1)

			const appraisalAttachIndex: number =
				this.appraisalToAttachDemand.findIndex(
					appraisal => appraisal.idMongo === appraisalSelected.idMongo
			)

			if (appraisalAttachIndex != -1) {
				this.appraisalToAttachDemand.splice(appraisalAttachIndex, 1)
			}
		}
	}

	public emptyManySelectAppraisals() {
		this.appraisalsManySelected = []
		this.appaisalIdToAttachDemand = []
		this.appraisalToAttachDemand = []
		this.manyDemandsForNotify = {
			countDemandsWithoutRequester: 0,
			demandsSelected: [],
			idMongoDemandsSelected: [],
			requesterSelected: []
		}
	}

	// Método para lidar com o evento de storage
	public handleAssignReportEvent = (event: StorageEvent) => {
		if (event.key === 'unassignReport') {
			const demandsSelected: Array<{idMongo: string, cpfRequester: string,
				requester?: string, emailRequester?: string}> = JSON.parse(event.newValue)

			demandsSelected.forEach(demandSelected => {
				const demandIsSelected: boolean = this.demandIsAlreadySelected(demandSelected.idMongo)

				if (demandIsSelected) {
					this.removeDemandFromManyNotify({ idMongo: demandSelected.idMongo, cpfRequester: demandSelected.cpfRequester })
				}
			})
		}
		this.reloadTable()
	}

	public showSubdemands(demand: ListDemandHistory) {
		demand.showDetails = !Boolean(demand.showDetails)
	}

	public clearSelections() {
		this.appraisalsManySelected = []
		this.appraisalsManySelectedReport = []
		this.emptyManySelectAppraisals()
		this.generalPositionOfItensSelected = []
		this.pagesWithItensSelected = []
	}

	public ngOnDestroy() {
		window.removeEventListener('storage', this.handleAssignReportEvent)
	}

	
	public openSetTable() {
		this.showSetTable = !this.showSetTable;
	}

	public setNewTableConfig(configColumns: ColumnMapType) {
		this.settingsTable = configColumns;
		setTableConfiguration(TablesPanel.HISTORY_APPRAISAL, configColumns);
		this.openSetTable();
	}
}
